export const deepCompareOrdinal = (objA, objB) => JSON.stringify(objA) === JSON.stringify(objB);

const objectAlikeTypes = {
    object: 'Object',
    array: 'Array',
    date: 'Date',
};

const getObjectAlikeType = item => {
    const itemTypeString = Object.prototype.toString.call(item);
    const itemType = itemTypeString.substring(8, itemTypeString.length - 1);
    switch (itemType) {
        case objectAlikeTypes.object:
        case objectAlikeTypes.array:
        case objectAlikeTypes.date:
            return itemType;
    }

    return null;
};

export const mergeDeep = (target, ...sources) => {
    const outputType = getObjectAlikeType(target);

    const output = outputType === objectAlikeTypes.array ? target.slice(0) : { ...target };

    if (!sources.length) {
        return output;
    }

    const source = sources.shift();

    const sourceType = getObjectAlikeType(source);

    if (outputType && sourceType) {
        Object.keys(source).forEach(key => {
            const keyType = getObjectAlikeType(source[key]);

            switch (keyType) {
                case objectAlikeTypes.object:
                    output[key] === undefined && (output[key] = {});
                    output[key] = mergeDeep(output[key], source[key]);
                    break;
                case objectAlikeTypes.array: {
                    const outputKeyType = getObjectAlikeType(output[key]);

                    if (output[key] === undefined || outputKeyType !== objectAlikeTypes.array) {
                        output[key] = [];
                    }

                    output[key] = mergeDeep(output[key], source[key]);
                    break;
                }
                case objectAlikeTypes.date:
                    output[key] = new Date(source[key].getTime());
                    break;
                default:
                    output[key] = source[key];
            }
        });
    }

    return outputType ? mergeDeep(output, ...sources) : mergeDeep(output, source);
};

export const hasNone = value => value === null || value === undefined;

/**
 * @example
 * const flatObject3 = { 'a.b': 4, 'c.d': 5 };
 * unflattenObject(flatObject, '.') // => { a: { b: 4 }, c: { d: 5 } }
 *
 * @param {Object} obj
 * @param {string} separator
 */
export const unflattenObject = (obj, separator = '.') =>
    Object.keys(obj).reduce((unflattedObject, key) => {
        const keyArray = key.split(separator);
        let base = unflattedObject;
        while (keyArray.length) {
            const currentKey = keyArray.shift();
            base[currentKey] = keyArray.length ? base[currentKey] || {} : obj[key];
            base = base[currentKey];
        }
        return unflattedObject;
    }, {});

/**
 * Конвертирует объект, сгруппированный по некому ключу в массив.
 *
 * @example
 * const obj = var obj = { xxx: { a: 4, age: 5 }, yyy: { a: 1, b: 8 }};
 * groupedObjectToArray(obj, 'id')
 * // [
 * //    { a: 4, b: 5, id: "xxx" },
 * //    { a: 1, b: 8, id: "yyy" }
 * // ]
 *
 * @param {Object} obj
 * @param {string} groupProp - если передан, ключ, по которому сгруппирован объект будет добавлен в элемент массива с этим именем
 */
export const groupedObjectToArray = (obj, groupProp) =>
    Object.entries(obj).map(entry => {
        const [key, value] = entry;
        if (groupProp && typeof value === 'object') {
            value[groupProp] = key;
        }
        return value;
    });

/**
 * Принимает плоский объект, где ключ значение соотвественно ключ и значение
 * queryString. Возвращает массив вида ['key1=value1', 'key2=value2']
 * @param {Object<any, any>} obj
 */
export const flatObjToQueryPairsArray = obj => {
    const result = [];
    for (const [param, value] of Object.entries(obj)) {
        if (value) result.push(`${param}=${value}`);
    }
    return result;
};
